import React, { useRef, useEffect } from "react";
import Carrerssection from './Carrerssection';
import ValueFirstDatasection from './ValueFirstDatasection';
import Testimonialcards from './Testimonialcards';
import Carrersscrollcards from './Carrersscrollcards';
import Carrersjobs from './Carrersjobs';
import Carrersanimatedpage from './Carrersanimatedpage';
import CarrersLearnandLead from './CarrersLearnandLead';

const Bfsibuttons = () => {
  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);

  // Scroll to "Culture" section on component mount
  useEffect(() => {
    if (section1Ref.current) {
      section1Ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const scrollToSection = (ref) => {
    if (ref.current) {
      const topPosition = ref.current.getBoundingClientRect().top + window.pageYOffset - 80; // Adjust the `-50` for your desired offset
      console.log("Scrolling to:", topPosition);
      window.scrollTo({ top: topPosition, behavior: "smooth" });
    } else {
      console.error("Ref is not defined:", ref);
    }
  };



  return (
    <div>
      <style>
        {`
         

          .navigation {
            top: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            background-color: #fff;
            padding: 1px 0;
            z-index: 1000;
            margin-bottom: 50px;
          }

          .navigation button {
            margin: 0 1px;
            padding: 15px 30px;
            font-size: 18px;
            background-color: rgb(236 115 34);
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            width: 382px;
            text-align: center;
            transition: background-color 0.3s ease;
          }

          .navigation button:hover {
            background-color: #000;
          }

          .section {
            display: flex;
            justify-content: center;
            align-items: center;
          }
              @media (max-width: 768px) {
            .navigation {
              flex-direction: column;
              align-items: center;
              gap:10px;
            }

            .navigation button {
              width: 90%;
              max-width: none;
              font-size: 14px;
              padding: 10px;
            }
          }
        `}
      </style>

      <div className="navigation">
        <button>Banking</button>
        <button > Insurance </button>
        <button >Financial services</button>
        {/* <button >Pharma Packaging</button> */}
      </div>

      <div
        ref={section1Ref}
        className="section"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {/* <Carrerssection />
          <ValueFirstDatasection /> */}
      </div>

      <div ref={section2Ref} className="section"     style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}>
      
          {/* <Testimonialcards />
        <Carrersscrollcards /> */}
      </div>

      <div
        ref={section3Ref}
        className="section"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
      
        {/* <Carrersjobs /> */}
      </div>

      <div
        ref={section4Ref}
        className="section"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {/* <Carrersanimatedpage />
        <CarrersLearnandLead /> */}
      </div>
    </div>
  );
};

export default Bfsibuttons;
